import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
// import { ApolloProvider } from "@apollo/react-hooks";

import { ApolloProvider } from "@apollo/client";

import client from "./apolloSetup";

// import { createRoot } from "react-dom/client";
// import React from "react";
// import ReactDOM from "react-dom";
// import App from "./components/App";
// import { ApolloProvider } from "@apollo/react-hooks";
// import client from "./apolloSetup";
// import SimpleReactLightbox from "simple-react-lightbox";

// const container = document.getElementById("root");
// const root = createRoot(container);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ApolloProvider client={client}>
    {/* <SimpleReactLightbox> */}
    <App />
    {/* </SimpleReactLightbox> */}
  </ApolloProvider>
);
